import axios from '/@/utils/request'


const api = {
    getCodeList: '/base/comm/invitationByPage',
    getShareInfo:'/Invitation/shareSet',
    addCode:'/base/comm/createInvitation',
    updateCode:'/base/comm/updateInvitation',
    delCode:'/base/comm/deleteInvitation',
    getCodeDetailList:'/base/comm/getLoginAccountList',
    getFriendsDetail:'/base/comm/getSocialAccountFansList',
    createLink:'/base/comm/createLiveLink',
    getLiveLink:'/base/comm/liveLinkList',
    getChatTypeAccountCount:'/base/comm/getChatTypeAccountCount',
    clearLiveLinkPVAndIP:'/base/comm/clearLiveLink',
    deleteLiveLink:'/base/comm/deleteLiveLink',
    getInvCount:'/base/comm/getInvCount'
}

const getCodeList = (params:any) => {
    return axios({
        url: api.getCodeList,
        method: 'get',
        params
    })
}
const getShareInfo = (params:any) => {
    return axios({
        url: api.getShareInfo,
        method: 'post',
        data: params
    })
}
const addCode = (params:any) => {
    return axios({
        url: api.addCode,
        method: 'post',
        data: params
    })
}
const updateCode = (params:any) => {
    return axios({
        url: api.updateCode,
        method: 'post',
        data: params
    })
}
const delCode = (params:any) => {
    return axios({
        url: api.delCode,
        method: 'post',
        data: params
    })
}
const getCodeDetailList = (params:any) => {
    return axios({
        url: api.getCodeDetailList,
        method: 'get',
        params
    })
}
const getFriendsDetail = (data:any) =>{
    return axios({
        url: api.getFriendsDetail,
        method: 'post',
        data
    })
}
const createLink = (data:any) =>{
    return axios({
        url: api.createLink,
        method: 'post',
        data
    })
}
const getLiveLink =(data:any)=>{
    return axios({
        url: api.getLiveLink,
        method: 'post',
        data
    })
}
const getChatTypeAccountCount =(data:any) =>{
    return axios({
        url: api.getChatTypeAccountCount,
        method: 'post',
        data
    })
}
const clearLiveLinkPVAndIP =(data:any)=>{
    return axios({
        url: api.clearLiveLinkPVAndIP,
        method: 'post',
        data
    })
}
const  deleteLiveLink =(data:any)=>{
    return axios({
        url: api.deleteLiveLink,
        method: 'post',
        data
    })
}
const getInvCount = (data:any) => {
    return axios({
        url: api.getInvCount,
        method: 'post',
        data
    })
}

export {
    getCodeList,
    getShareInfo,
    addCode,
    updateCode,
    delCode,
    getCodeDetailList,
    getFriendsDetail,
    createLink,
    getLiveLink,
    getChatTypeAccountCount,
    clearLiveLinkPVAndIP,
    deleteLiveLink,
    getInvCount
}
